<template>
    <div class="description-instructions">
        {{ instructions }}
    </div>
</template>
<script>
export default {
    name: 'need-description-instructions',
    computed: {
        instructions () {
            return 'Articulate clear priorities through the identification of strengths and challenges, that include trends in performance for all and subgroups of students, grade bands/levels, and content areas.  Ensure required areas of ELA, math, college career readiness and/or ACT/SAT, graduation rate, and student attendance have been analyzed. ';
        }
    }
}
</script>
